export default {
  buttons: {
    save: 'Tallenna',
    confirm: 'Vahvista',
    cancel: 'Peruuta',
  },
  confirmation: {
    title: 'Haluatko varmasti synkronoida ulkoisiin palveluihin?',
  },
};
